module.exports = __webpack_public_path__ + "img/EricaKalivas.07a27199.jpg";